import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { disableLoginPopUps } from "@/redux/actions/patient";
import { Portal } from "@/components/Common/Modal/Portal";
import { selectAllowInactivePopUp } from "@/redux/selectors/patientSelectors";
import { selectIsPatientInactive } from "@/redux/selectors/authSelectors";
import {
  SUPPORT_EMAIL,
  SUPPORT_EMAIL_HREF,
  SUPPORT_NUMBER,
  SUPPORT_NUMBER_HREF,
} from "@/constants/aptihealth";
import { Text } from "@/component-library";

export function InactiveModal() {
  const dispatch = useDispatch();
  const isInactive = useSelector(selectIsPatientInactive);
  const allowInactivePopUp = useSelector(selectAllowInactivePopUp);

  if (!isInactive || !allowInactivePopUp) return null;

  return (
    <Portal
      className="take-assessment-modal"
      headerRender={<h5 className="border-bottom-0 tw:font-bold"></h5>}
      isBottomCloseActive={false}
      isOpenOnRender={true}
      onModalClose={() => dispatch(disableLoginPopUps())}
    >
      <div className="text-align-center mb-5 mx-5">
        <p className="mb-3">
          <Text type="heading-1">Your Account is Inactive</Text>
        </p>

        <p className="pb-2">
          <Text color="grey" type="paragraph">
            We're happy to see you! But your account is currently inactive. Please email us at{" "}
          </Text>

          <Text
            className="patient-contact-link"
            onClick={() => window.open(SUPPORT_EMAIL_HREF)}
            type="paragraph"
          >
            {SUPPORT_EMAIL}
          </Text>

          <Text color="grey" type="paragraph">
            {" "}
            or call us at{" "}
          </Text>

          <Text
            className="patient-contact-link"
            onClick={() => window.open(SUPPORT_NUMBER_HREF)}
            type="paragraph"
          >
            {SUPPORT_NUMBER}
          </Text>

          <Text color="grey" type="paragraph">
            {" "}
            to begin receiving care again.
          </Text>
        </p>

        <p>
          <Text color="grey" type="paragraph">
            In the meantime you will not be able to schedule new sessions or message your care team.
          </Text>
        </p>
      </div>
    </Portal>
  );
}
